module.exports = __webpack_public_path__ + "files/pougheon.98521e0e157d0bb26277db94e53bf21f.pdf";